const MAX_RECENT_TOURNAMENTS = 5

export default {
  setCurrentUser: (state, value) => {
    state.currentUser = value
    if (value) {
      //Vue.material.setCurrentTheme(value.role)
    }
  },

  setNotification: (state, value) => {
    state.notification = value
  },

  toggleMenuVisibility: state => {
    state.menuVisible = !state.menuVisible
  },

  pushToRecentTournamentId: (state, value) => {
    if (value) {
      if (!state.recentTournaments) state.recentTournaments = []
      const existingIndex = state.recentTournaments.findIndex(x => x.id === value.id)
      if (existingIndex >= 0) state.recentTournaments.splice(existingIndex, 1)
      state.recentTournaments.push(value)
      if (state.recentTournaments.length > MAX_RECENT_TOURNAMENTS) state.recentTournaments.shift()
    }
  },

  setCurrentLocationId: (state, value) => {
    state.currentLocationId = value
  },

  setShowThisMonth: (state, value) => {
    state.showThisMonth = value
  },
  setShowNextMonth: (state, value) => {
    state.showNextMonth = value
  },
  setShowFuture: (state, value) => {
    state.showFuture = value
  },
  setShowOlder: (state, value) => {
    state.showOlder = value
  },

  setShowCompleted: (state, value) => {
    state.showCompleted = value
  },
  setShowInProgress: (state, value) => {
    state.showInProgress = value
  },
  setShowReady: (state, value) => {
    state.showReady = value
  },
  setShowPending: (state, value) => {
    state.showPending = value
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/commonMutations.js